// extracted by mini-css-extract-plugin
module.exports = {"tips":"shoper_tips__2LT84"};